import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { UserClustersFragment, UserClustersGQL } from "@/core/graphql/graphql";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import {
  ClusterDetailsModalComponent,
} from "@/modules/clusters/components/cluster-details-modal/cluster-details-modal.component";
import { Column } from "@/shared/components/table/table.model";
import {
  USER_CLUSTERS_COLUMNS,
} from "@/modules/users/components/user-details-modal/components/user-clusters/user-clusters.const";
import {
  UserClustersDatasource,
} from "@/modules/users/components/user-details-modal/components/user-clusters/user-clusters.datasource";

@Component({
  selector: 'cosmos-user-clusters',
  templateUrl: './user-clusters.component.html',
  styleUrls: ['./user-clusters.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserClustersComponent implements OnInit, OnDestroy {
  @ViewChild('imageCell', { static: true }) public imageCell: TemplateRef<UserClustersFragment>;
  @ViewChild('checkboxTemplate', { static: true }) public checkboxTemplate: TemplateRef<UserClustersFragment>;

  public _columns: Column<UserClustersFragment>[] = [];
  public _dataSource: UserClustersDatasource;
  public _loading$: Observable<boolean>;
  private readonly _subscription: Subscription = new Subscription();

  public constructor(
    private readonly _userClustersGql: UserClustersGQL,
    private readonly _dialog: CosmosDialogService,
    @Inject(MAT_DIALOG_DATA) private readonly _data: { userId: number },
  ) {
    this._dataSource = new UserClustersDatasource(_userClustersGql, _data.userId);
    this._loading$ = this._dataSource._loading$;
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public ngOnInit(): void {
    this._columns = USER_CLUSTERS_COLUMNS(this.imageCell, this.checkboxTemplate);
    this._dataSource.loadData(null);
  }

  public openClusterDetails(data: UserClustersFragment): void {
    this._dialog.open<ClusterDetailsModalComponent, { elementId: number }>(ClusterDetailsModalComponent, {
      data: {
        elementId: data.id,
      },
      style: CosmosDialogStyle.Dark,
    });
  }
}
